<template>
    <div>
        <images-carousel
            :height="$vuetify.breakpoint.smAndDown ? '300px' : '500px'"
            :galleryElements="galleryElements"
            @onImageClick="displayGallery = true"
            v-model="currentSlide"
            :hide-controls="$vuetify.breakpoint.smAndDown"
            :discount-rate="discountRate"
            no-shadow
            :paginator="$vuetify.breakpoint.mdAndUp ? 'prime-carousel-preview-pagination' : undefined"
            contain
            :loop="true"
            class="fill-height"
            ref="carousel"
        ></images-carousel>

        <wheel-zoomer
            v-model="displayGallery"
            :galleryElements="galleryElements"
            :currentSlide="currentSlide"
            @slideChange="onSlideChange"
        ></wheel-zoomer>
    </div>
</template>

<script>
import ImagesAndVideos from '@breakmedia/prime-vue-product/src/product-page/ImagesAndVideos';
import ImagesCarousel from './ImagesCarousel';

export default {
    extends: ImagesAndVideos,
    components: {
        ImagesCarousel
    }
};
</script>
